import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

type Params = Pick<ChallengeFormType, 'isDeleted'>;

export const validate: FormValidator<Params> = ({ isDeleted }) => {
  if (typeof isDeleted !== 'boolean') {
    return { isValid: false, message: '챌린지 삭제 여부를 확인해주세요' };
  }

  return { isValid: true };
};
